const getProgress = (rootState) => rootState.ui.starterScreen.progress;

export default getProgress;
